import { Component, Prop, h } from '@stencil/core';

import { MockQrCode } from './mock-qr-code';

@Component({
  tag: 'qr-code',
  styleUrl: 'qr-code.css',
})
// QR Code Component not finalized, might change when adding in real QR code generation logic
export class QRCode {
  @Prop() url: string;
  @Prop() widthPx: number = 200;
  @Prop() heightPx: number = 200;

  render() {
    return (
      <div datatest-id="qr-code" style={{ width: `${this.widthPx}px`, height: `${this.heightPx}px` }}>
        <MockQrCode />
      </div>
    );
  }
}
